import React, { FC, memo, useMemo } from 'react';
import styled from 'styled-components';
import { Input, Select, Space } from 'udesk-ui';

const OperatorMap = {
    IS: 'is',
    IS_NOT: 'is not',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'not contains',
    IS_NULL: 'is null',
    IS_NOT_NULL: 'is not null',
};

const Wrapper = styled.div``;

export interface TemplateProps {
    value?: {
        fieldName?: string;
        operator?: string;
        fieldValue?: string;
    };
    onChange?: (v: TemplateProps['value']) => void;
    disabled?: boolean;
}

const Template: FC<TemplateProps> = (props) => {
    const { value, onChange, disabled } = props;

    const operatorOptions = useMemo(
        () => [
            {
                label: '等于',
                value: OperatorMap.IS,
            },
            {
                label: '不等于',
                value: OperatorMap.IS_NOT,
            },
            {
                label: '包含',
                value: OperatorMap.CONTAINS,
            },
            {
                label: '不包含',
                value: OperatorMap.NOT_CONTAINS,
            },
            {
                label: '为空',
                value: OperatorMap.IS_NULL,
            },
            {
                label: '不为空',
                value: OperatorMap.IS_NOT_NULL,
            },
        ],
        []
    );

    return (
        <Wrapper>
            <Space>
                <Input
                    maxLength={200}
                    value={value?.fieldName}
                    onChange={(e) =>
                        onChange?.({
                            ...value,
                            fieldName: e.target.value,
                        })
                    }
                    disabled={disabled}
                />

                <Select
                    options={operatorOptions}
                    value={value?.operator}
                    onChange={(e) => onChange?.({ ...value, operator: e, fieldValue: undefined })}
                    disabled={disabled}
                />

                {value?.operator === OperatorMap.IS ||
                value?.operator === OperatorMap.IS_NOT ||
                value?.operator === OperatorMap.CONTAINS ||
                value?.operator === OperatorMap.NOT_CONTAINS ? (
                    <Input
                        maxLength={200}
                        value={value?.fieldValue}
                        onChange={(e) => onChange?.({ ...value, fieldValue: e.target.value })}
                        disabled={disabled}
                    />
                ) : null}
            </Space>
        </Wrapper>
    );
};

export default memo(Template);
